module.exports = __webpack_public_path__ + "static/media/import.3f2ddd08.svg";